import React from 'react';
import shallow from 'zustand/shallow';
import { setNodes } from '@udecode/plate-core';
import { FormInputElement } from '@typedream/core';
import styles from '../SideToolbar.module.css';
import { useDreamEditorStore } from '../../../plugins/store';
import { useTPlateEditorRef } from '../../../plate';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';

function InputRequired() {
  const editor = useTPlateEditorRef();

  const currentChecked = useDreamEditorStore(() => {
    const entry = getSelectedElementEntry(editor);

    if (!entry) return false;
    const [el] = entry;
    return (el as FormInputElement)?.required || false;
  }, shallow);

  const handleRequiredToggle = () => {
    const entry = getSelectedElementEntry(editor);
    if (!entry) return;

    const [, path] = entry;

    setNodes(editor, {
      required: !currentChecked,
    }, {
      at: path,
    });
  };

  return (
    <div className="mt-5 mb-5">
      <div className="is-flex is-justify-content-space-between is-align-items-center">
        <div className={styles.label}>
          Required Field
        </div>
        <div
          className="field is-flex is-justify-content-center is-align-items-center"
        >
          <input
            id="inputRequiredToggle"
            type="checkbox"
            name="inputRequiredToggle"
            className="switch is-rounded is-small is-primary is-rtl"
            checked={currentChecked}
            onChange={handleRequiredToggle}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="inputRequiredToggle" className={styles.label} />
        </div>

      </div>
    </div>
  );
}

export default InputRequired;
